<div class="ui-g ui-g-fluid container" id="documento-folha-em-branco">
  <div class="header ui-g-12 no-padding">
    <div class="row">
      <!-- LEFT HEADER -->
      <div class="header-left ui-sm-4 ui-g-6">
        <img alt="logo" 
             src='{{ arquivoLogoGrandeHorizontal }}'
             style="max-width: 192px; display: block;" />
        
        <!-- <div class="header-row no-bottom-space"> -->
          <!-- <label class="ui-g-4">Empresa: </label> -->
        <!-- </div>         -->
        
        <div class="header-row no-bottom-space">
          <label class="ui-g-12 label-titulo label-versao no-bottom-space">{{nomeEmpresaCliente}}</label>
          <!-- <label class="ui-g-4">Versão: </label> -->
          <span class="ui-g-12 label-versao texto-cinza-claro no-top-space">
            versão:
            <span class="versao-ui">ui {{versaoUI}}</span>
            <span class="versao-api">api {{versaoAPI}}</span>
          </span>
        </div>
      </div>
  
  
      <!-- RIGHT HEADER -->
      <div class="header-right ui-sm-8 ui-g-6">
        <div class="header-row">
          <label class="ui-g-12 header-nome-relatorio label-titulo no-top-space no-bottom-space">{{nomeRelatorio}}</label> <!-- | uppercase -->
        </div>
        <div class="first-header-row header-row no-top-space no-bottom-space" *ngIf="acao !== 'formulario'">
          <span class="ui-g-4 label-titulo">Data:</span>
          <label class="ui-g-8 label-valor">{{dataAtual | myDatetime}}</label>
        </div>
        <div class="header-row no-top-space no-bottom-space" *ngIf="exibirUsuario && (acao !== 'formulario')">
          <span class="ui-g-4 label-titulo">Usuário:</span>
          <label class="ui-g-8 label-valor">{{usuarioExecutor}}</label>
        </div>        
      </div>

      <div class="ui-g-12 divisor-fundo-cinza" *ngIf="acao === 'formulario'"></div>

    </div>
  </div>
</div>